import {default as _ } from 'lodash';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { FinraExceptionService } from '../finra-exception.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserService } from 'app/Shared/Services/user.service';
import {default as CreateParentColumnsJSON} from '../create-parent/Create-Parent-Columns.json';
import { GridService } from 'app/Shared/Services/grid.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { ConfirmationService,MessageService } from 'primeng/api';
import { DataService } from 'app/Shared/Services/data.service';
import { DialogModule } from 'primeng/dialog';
import { LowerCasePipe, NgClass,CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { Select } from 'primeng/select';

@Component({
    selector: 'app-create-parent',
    imports: [DialogModule,CommonModule,MatProgressSpinner, NgClass, Select, ButtonModule, LowerCasePipe, FormsModule],
    templateUrl: './create-parent.component.html',
    styleUrls: ['./create-parent.component.scss']
})
export class CreateParentComponent implements OnInit {
  @Input() pageName!: string;
  @Input() totalRecords: any;
  @Input() defaultFilters: any;
  @Input() selectedRecords: any;
  @Output() PostCreateParentAction: EventEmitter<any> = new EventEmitter();
  

  loading!: boolean;
  isClickedOnce!: boolean;
  columnJson: any = [];
  createParentCols: any;
  getData: any = '';
  createParentColumnDetails: any = [];
  isLoadingResults: boolean = false;

  constructor(public finraExceptionService: FinraExceptionService,
    private UrlsService: UrlsService,
    private userService: UserService,
    public constantService: ConstantService,
    private SharedHttpClientService: SharedHttpClientService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private gridService: GridService,
    public dataService:DataService ) {
    this.createParentCols = CreateParentColumnsJSON["createParentColumns"];
  }

  ngOnInit() {
    this.loading = false;
    this.getCreateParentColumns();
  }

  getCreateParentColumns() {

    this.createParentColumnDetails = [];
    for (let i = 0; i < Object.keys(this.createParentCols).length; i++) {
      let Field_Dictionary_Object: any;
      Field_Dictionary_Object = this.userService.getFieldDictionaryObject(this.createParentCols[i]["mappingkey"]);
      this.createParentColumnDetails.push({
        "ui_Field_Name": this.createParentCols[i]["ui_columnname"],
        "field_Name": this.createParentCols[i]["mappingkey"],
        "value": this.createParentCols[i]["value"],
        "datatype": this.createParentCols[i]["datatype"],
        "display": this.createParentCols[i]["display"],
        "db_columnname": this.createParentCols[i]["db_columnname"],
        "dropdown": this.createParentCols[i]["dropdown"],
        "dropdowntype": this.createParentCols[i]["dropdowntype"] ? this.createParentCols[i]["dropdowntype"] : (Field_Dictionary_Object["dropdowntype"] ? Field_Dictionary_Object["dropdowntype"] : ""),
        "dropdownvalue": (_.includes(["groupname"], this.createParentCols[i]["ui_columnname"].toLocaleLowerCase()) ? this.finraExceptionService.groupListDropDown : Field_Dictionary_Object["dropdownvalue"]),
        "isDisable": (this.createParentCols[i]["disabled"] ? this.createParentCols[i]["disabled"] : false),
        "placeholder": (this.createParentCols[i]["placeholder"] ? this.createParentCols[i]["placeholder"] : "Please Enter Value"),
        "isrequired": (this.createParentCols[i]["isrequired"] ? this.createParentCols[i]["isrequired"] : false),
        "maximumLength": (this.createParentCols[i]["maxlength"] ? this.createParentCols[i]["maxlength"] : ""),
        "regexpressions": (this.createParentCols[i]["regexpressions"] ? this.createParentCols[i]["regexpressions"] : ""),
        "errorFields": ""
      });
    }
  }

  onSave() {
    this.validateFields(this.createParentColumnDetails); // Validate Form Fields

    let updatedJSONobject: any = {};
    let selectedRecordIds = [];

    let errorFields = this.createParentColumnDetails.filter((fieldDetail: { errorFields: string | any[]; }) => fieldDetail.errorFields.length > 0);
    if(errorFields.length > 0) {
      return false;
    } else {
      // Preapare Form Data Fields Parameters Object
      for (let i = 0; i < this.createParentColumnDetails.length; i++) {
        updatedJSONobject[this.createParentColumnDetails[i]["field_Name"]] = this.createParentColumnDetails[i]["value"];
      }

      // If We have selected Records then receive Ids of Selected ones
      if(this.selectedRecords.length > 0) {
        selectedRecordIds = this.selectedRecords.map((recordObj: { id: any; }) => recordObj.id);
      }
    }
    this.isLoadingResults = true;

    /* Receive all ME* & MO* EventTypes Values */
      let indexForEventTypeValue = this.defaultFilters.findIndex(function (item: { label: string; }) {
        return item.label === "Type"
      });

      const optedEventTypes = this.defaultFilters[indexForEventTypeValue]["values"];
      let ME_EventTypes = optedEventTypes.filter((item: string) => item.startsWith("ME"));
      let MO_EventTypes = optedEventTypes.filter((item: string) => item.startsWith("MO"));
    /* End of Receiving all ME* & MO* EventTypes Values */

    let payload = {
      "pageName": this.pageName,
      "mpid": this.userService.getActiveMPID(),
      "eventTypes": this.gridService.getEventsList(this.defaultFilters, 'Type'),
      "ME_EventTypes": ME_EventTypes.map((eventType: any) => `'${eventType}'`).join(", "), 
      "MO_EventTypes": MO_EventTypes.map((eventType: any) => `'${eventType}'`).join(", "),
      "data": this.defaultFilters,
      "selectedRecordIds": selectedRecordIds,
      "updatedJSONObject": updatedJSONobject,
      "user": this.userService.getUserFirstName(),
      "userid": this.userService.getUid()
    }

    this.SharedHttpClientService.post(
      this.UrlsService.setAPIURl(
        APIURL.FINRA_CREATE_PARENT
      ), payload
    ).subscribe({
      next: (Element:any) => {
        let dataset: any = Element;

        if (dataset.Status === true) {
          this.messageService.add({ severity: 'success', summary: 'Updated', detail: 'Parent Created Sucessfully!' });
          this.userService.logUserActivity('Create Parent', null, {
            'Text1': 'Parent Creation for ' + ((this.totalRecords > 0) ? this.totalRecords : 0) + ' records Successfully',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.defaultFilters.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Update', detail: 'Parent Creation Failed!' });
          this.userService.logUserActivity('Create Parent', null, {
            'Text1': 'Failed Parent Creation for ' + ((this.totalRecords > 0) ? this.totalRecords : 0) + ' records',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.defaultFilters.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        }

        this.isClickedOnce = false;
        this.isLoadingResults = false;
        
        this.PostCreateParentAction.emit(); // Call-back to Parent Component
      }, error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: 'error', summary: 'Update', detail: 'Parent Creation Failed!' });
        this.userService.logUserActivity('Create Parent', null, {
          'Text1': 'Failed Parent Creation for ' + ((this.totalRecords > 0) ? this.totalRecords : 0) + ' records',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.defaultFilters.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
        this.isClickedOnce = false;
        this.isLoadingResults = false;
      }});

    // @CHECKME
    return true;

  }

  validateFields(screenFields: any) {
    if(screenFields.length > 0) {
      for(let i=0; i<screenFields.length; i++) {
        /* Required Field Validation */
        if(screenFields[i]["isrequired"]===true && screenFields[i]["isDisable"]!==true && (!screenFields[i]['value'] || screenFields[i]['value']==="" || screenFields[i]['value']===null)) {
          screenFields[i]['errorFields'] = "Please enter required field";
          continue;
        } else if(screenFields[i]["isrequired"]===true && screenFields[i]['value']) {
          screenFields[i]['errorFields'] = "";
        }

        /* Regular Expression Field Validation */
        if(screenFields[i]["regexpressions"] && screenFields[i]["regexpressions"].length > 0) {
          let validFieldFormat = false;
          for(let j=0; j<screenFields[i]["regexpressions"].length; j++) {
            if(new RegExp(screenFields[i]["regexpressions"][j]).test(screenFields[i]['value'])===true) {
              validFieldFormat = true;
              screenFields[i]['errorFields'] = "";
            }
          }
          if(validFieldFormat === false) {
            screenFields[i]['errorFields'] = "Please enter valid format";
            continue;
          }
        }
      }
    }
  }

  onClose() {
    this.finraExceptionService.showCreateParentScreen = false;
  }

}